import type { FaireProductEntity } from "../../entity_types/product";

export const p_4ewckw6wgm: FaireProductEntity = {
  token: "p_4ewckw6wgm",
  type: "product",
  name: "Women's Soft Ruffle Chenille 51\" Wrap Robe",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/01adbe5d037f9bb2a15d544bd7558165c54e74d1dd5f29a71af3d7c0b1cdc1ca.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/680cdf3f2283764dda0d9958cee2e8d8f340a62371d0f9515f977dd36c11ba6a.jpeg",
    "https://cdn.faire.com/fastly/8b3c86913a08adc1b6e6ef40299d33e5025cce58d51a7ced63d61da28f684d7a.png",
    "https://cdn.faire.com/fastly/3db6e52e13c7bafcd83849fadc8e0bba099fbfc25513c34cf6fc76852f3084c6.jpeg",
    "https://cdn.faire.com/fastly/23fb7b875765490411c8676738ac263ae003d95a4512fca5c8aed4a47276be2e.png",
    "https://cdn.faire.com/fastly/f3ccd743dcfa2f7522e526d0e990389159f6fad9a8b600869511e02d36cee8a0.png",
    "https://cdn.faire.com/fastly/a8ab09072ad9c63e9dff1e3df21d7bb4c2f5eaebb5ec6826035e472d10d9685f.png",
    "https://cdn.faire.com/fastly/ba4252b8ed5700ffb6ef28c6e825a7eb9ebd416c4a76e586f52333f3615f3bd8.png",
    "https://cdn.faire.com/fastly/9d320c84180b8588d6506dbd92ca0e695066c87ae953e06a41a507b0f5f276da.jpeg",
    "https://cdn.faire.com/fastly/8b718161ba5e58571eba23b3783cae8c5cce9c4a080760d7c7e96b745b64a6ab.jpeg",
    "https://cdn.faire.com/fastly/fe590ea64309efd2953a0e99463663fb0ba6609baddc29a710471aea47110323.png",
    "https://cdn.faire.com/fastly/24120c0e78e997305b0cb909db24b3faf622bcc56b9adef846dee31e87799af2.jpeg",
    "https://cdn.faire.com/fastly/df3a285b57293c930023cfa8aa1fb6340498ca395fc7b67b51f181d82af6c531.jpeg",
    "https://cdn.faire.com/fastly/160863f1101040dfa928a06e9b79ef5d6078fa1bd23b38f4f94fc431137b451f.png",
    "https://cdn.faire.com/fastly/38ee187d2fb0c74e46cabbaa2c1a170501f950ed18b51fbf473d682b9c935d65.png"
  ],
  priceDollars: 65,
  description: "Surround yourself in total comfort with our 51″ ruffled trim robe hand stitched in gorgeous colors. The cascading ruffle softly drapes the neck and gives these classically comfortable robes a flirty, feminine flair. Inside tie, side seam pockets.\n\n𝐅𝐞𝐚𝐭𝐮𝐫𝐞𝐬\n• 51” length chenille robe\n• Hand-stitched cascading ruffle\n• Inside tie\n• Hidden side seam pockets\n• Bracelet length sleeves and fashionable bell sweep\n\n𝐌𝐚𝐭𝐞𝐫𝐢𝐚𝐥𝐬 & 𝐂𝐚𝐫𝐞\n• 100% polyester chenille\n• Easy-care, colorfast and lightweight\n• Machine washable",
  tags: [],
  msrpDollars: 130,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:14.270Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
